import { render, staticRenderFns } from "./HelpDeskView.vue?vue&type=template&id=35349728"
import script from "./HelpDeskView.vue?vue&type=script&lang=js"
export * from "./HelpDeskView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports